import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { MarketProjectPage } from '@/features/marketPromotion/pages/MarketProjectPage';
import { marketProjectSearchSchema } from '@/features/marketPromotion/types/marketPromotionP2.types';

export const Route = createFileRoute('/_auth/market-promotion/projects')({
  validateSearch: marketProjectSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Market Promotion Project">
      <Suspense fallback={<PageLoader />}>
        <MarketProjectPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
